
import React from 'react'
import { fetchAllMovies, fetchAllCinemaNews, Movie, CinemaNews } from '../api/movies'

export const useCinemaData = () => {
    const [movies, setMovies] = React.useState<Movie[]>([])
    const [news, setNews] = React.useState<CinemaNews[]>([])
    const [loading, setLoading] = React.useState(true)
    const [error, setError] = React.useState<Error | null>(null)

    React.useEffect(() => {
        const loadData = async () => {
            setLoading(true)
            try {
                const [moviesData, newsData] = await Promise.all([
                    fetchAllMovies(),
                    fetchAllCinemaNews()
                ])
                setMovies(moviesData)
                setNews(newsData)
            } catch (err) {
                console.error('Failed to load cinema data:', err)
                setError(err instanceof Error ? err : new Error('Unknown error'))
            } finally {
                setLoading(false)
            }
        }
        loadData()
    }, [])

    return { movies, news, loading, error }
}
